import { cn } from "@/lib/utils";
import { Card } from "../card/card";
import { CrossCircledIcon } from "@radix-ui/react-icons";
import { CheckCircle2 } from "lucide-react";
import { Loader } from "../loader/loader";
import { PropsWithChildren, ReactNode } from "react";

export interface TaskStatusProps extends PropsWithChildren {
  status: "default" | "success" | "error";
  isLoading: boolean;
}

export function TaskStatus({ status, isLoading, children }: TaskStatusProps) {
  const icon: Record<TaskStatusProps["status"], ReactNode> = {
    success: <CheckCircle2 className="h-5 w-5 " />,
    error: <CrossCircledIcon className="h-5 w-5 " />,
    default: null,
  };

  const bg: Record<TaskStatusProps["status"], string> = {
    success: "bg-success-lighter",
    error: "bg-destructive-lighter",
    default: "",
  };

  return (
    <Card
      className={cn(
        "flex flex-col items-center p-4 shadow-task-sm",
        bg[status]
      )}
    >
      <div className="flex items-center h-5">
        {isLoading ? <Loader className="text-primary" /> : icon[status]}{" "}
      </div>

      <div className={cn("text-lg font-bold")}>{children}</div>
    </Card>
  );
}
